import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { AdditiveBlending } from 'three';
import { Atmosphere } from './Atmosphere.jsx';
import { softSpriteTexture } from './softSprite.js';

// Emissive star: the ONLY thing pushed over bloom threshold (color > 1 +
// toneMapped false → selective Bloom catches it, research §4/§6), plus a
// sprite corona that breathes and a warm fresnel halo.
export function Star({ position = [0, 0, 0], scale = 1, coreColor = [3.4, 2.2, 1.1], haloColor = '#ffb85c' }) {
  const coronaRef = useRef();
  const glow = softSpriteTexture({
    stops: [
      [0, 'rgba(255,214,150,0.9)'],
      [0.25, 'rgba(255,178,92,0.38)'],
      [0.6, 'rgba(255,140,60,0.1)'],
      [1, 'rgba(255,120,40,0)'],
    ],
  });

  useFrame((state) => {
    if (!coronaRef.current) return;
    const pulse = 1 + Math.sin(state.clock.elapsedTime * 0.8) * 0.04 + Math.sin(state.clock.elapsedTime * 2.7) * 0.015;
    coronaRef.current.scale.setScalar(3.4 * pulse);
  });

  return (
    <group position={position} scale={scale}>
      <mesh>
        <sphereGeometry args={[0.34, 48, 24]} />
        <meshBasicMaterial color={coreColor} toneMapped={false} />
      </mesh>
      <Atmosphere radius={0.34} color={haloColor} power={6} intensity={0.9} scale={1.35} />
      <sprite ref={coronaRef} scale={3.4}>
        <spriteMaterial map={glow} transparent depthWrite={false} blending={AdditiveBlending} />
      </sprite>
    </group>
  );
}
